if (!customElements.get("social-banner-slider")) {
  customElements.define(
    "social-banner-slider",
    class SocialBannerSlider extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          swiper: this.querySelector(".social-banner__swiper"),
        };

        const swiper = new Swiper(this.elements.swiper, {
          // Optional parameters
          slidesPerView: 1.15,
          spaceBetween: 0,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          loop: true,
          autoplay: {
            delay: 2000, // Change the delay value as needed (in milliseconds)
            disableOnInteraction: false, // Allow autoplay to continue even when user interacts with the slider
          },

          breakpoints: {
            768: {
              slidesPerView: 4.5,
              spaceBetween: 0,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              centeredSlides: true,
            },
          },
        });
      }
    }
  );
}
